/* assets/fhn-qty-sync.js
   1. Hace funcionar los botones − / + del formulario principal.
   2. Si la cantidad es 4 o más, deja seleccionado el tier de 3 en xboost.
   3. Sincroniza la cantidad entre formulario principal, xboost y barra inferior.
   4. Controla cuándo se ve la barra inferior (sticky add to cart).
*/
(function () {
    
  if (window.__fhnQtySync) return;
  window.__fhnQtySync = true;

  // ===== CONFIGURACIÓN (ajustar si xboost cambia su HTML) =====
  var CFG = {
    xboostRoot: '.xboost-auto-add',
    // Cada opción de cantidad de xboost. Se detecta su número por el texto "Compra N".
    tierRegex: /Compra\s*(\d+)/i,
    maxTier: 3,
    mainForm: 'form[data-type="add-to-cart-form"]:not(.is--atc-sticky)',
    stickyBar: '[data-sticky-addtocart]',
    qtyInput: '.ontime-quantity-input[data-quantity-value]',
    stickyQtyInput: '.t4s-quantity-input[data-quantity-value]',
    mainButtons: '.t4s-product-form__buttons'
  };

  var mainForm, stickyBar, mainQty, stickyQty;
  var lock = false;        // evita bucles al sincronizar
  var desired = null;      // cantidad que el usuario pidió (para no perderla cuando xboost escribe 3)


  function clamp(n, input) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 9999;
    n = parseInt(n, 10);
    if (isNaN(n)) n = min;
    return Math.max(min, Math.min(max, n));
  }

  // Escribe el valor sin disparar nuestro propio observador
  function writeValue(input, n) {
    console.log({input})
    if (!input || String(input.value) === String(n)) return;
    lock = true;
    input.__fhnSet ? input.__fhnSet(n) : (input.value = n);
    lock = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ----- xboost: encontrar la opción de N unidades -----
  function tierElements() {
    var root = document.querySelector(CFG.xboostRoot);
    if (!root) return [];
    var seen = [];
    root.querySelectorAll('*').forEach(function (el) {
      var m = (el.textContent || '').match(CFG.tierRegex);
      if (!m) return;
      // Nos quedamos con el elemento más externo que contiene un solo "Compra N"
      var matches = (el.textContent.match(new RegExp(CFG.tierRegex.source, 'gi')) || []).length;
      if (matches !== 1) return;
      if (seen.some(function (s) { return s.el.contains(el); })) return;
      seen = seen.filter(function (s) { return !el.contains(s.el); });
      seen.push({ el: el, n: parseInt(m[1], 10) });
    });
    return seen;
  }

  function realClick(el) {
  var r = el.getBoundingClientRect();
  var x = r.left + r.width / 2;
  var y = r.top + r.height / 2;
  // El elemento que de verdad está bajo el cursor en ese punto
  var target = document.elementFromPoint(x, y);
  if (!target || !el.contains(target)) target = el;

  var opts = { bubbles: true, cancelable: true, composed: true, view: window, clientX: x, clientY: y, button: 0 };
  var pOpts = Object.assign({ pointerId: 1, pointerType: 'mouse', isPrimary: true }, opts);

  target.dispatchEvent(new PointerEvent('pointerdown', pOpts));
  target.dispatchEvent(new MouseEvent('mousedown', opts));
  target.dispatchEvent(new PointerEvent('pointerup', pOpts));
  target.dispatchEvent(new MouseEvent('mouseup', opts));
  target.dispatchEvent(new MouseEvent('click', opts));
}

function selectTier(n) {
  var target = Math.min(n, CFG.maxTier);
  var tier = tierElements().find(function (t) { return t.n === target; });
  if (!tier) return;

  // Si hay un radio real, marcarlo y avisar del cambio
  var radio = tier.el.querySelector('input[type="radio"]');
  if (radio) {
    if (radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
  realClick(tier.el);
}

  // ----- Propagar una cantidad a todos lados -----
  function setQty(n, source) {
    if (mainQty) n = clamp(n, mainQty);
    desired = n;
    if (source !== 'main') writeValue(mainQty, n);
    if (source !== 'sticky') writeValue(stickyQty, n);
    if (source !== 'xboost') {
      selectTier(n);
      // xboost puede reescribir la cantidad a 3: la restauramos
      if (n > CFG.maxTier) setTimeout(function () { writeValue(mainQty, desired); writeValue(stickyQty, desired); }, 60);
    }
  }

  // Intercepta asignaciones programáticas a input.value (así detectamos cuando xboost escribe la cantidad)
  function watchInput(input, source) {
    if (!input || input.__fhnWatched) return;
    input.__fhnWatched = true;
    var proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    input.__fhnSet = function (v) { proto.set.call(input, v); };
    Object.defineProperty(input, 'value', {
      configurable: true,
      get: function () { return proto.get.call(input); },
      set: function (v) {
        proto.set.call(input, v);
        if (lock) return;
        var n = parseInt(v, 10);
        if (source === 'main' && desired > CFG.maxTier && n === CFG.maxTier) {
          setTimeout(function () { writeValue(input, desired); });
          return;
        }
        if (!isNaN(n)) setQty(n, source === 'main' ? 'xboost' : source);
      }
    });
  }

  // Tecleo: escuchamos en el documento en fase de captura, antes que el tema y xboost
  function sourceOf(el) {
    if (el === mainQty) return 'main';
    if (el === stickyQty) return 'sticky';
    return null;
  }
  document.addEventListener('input', function (e) {
    var src = sourceOf(e.target);
    if (!src || lock) return;
    var n = parseInt(e.target.value, 10);
    if (isNaN(n) || n < 1) return; // campo vacío mientras se escribe
    desired = n;
    // Mientras se escribe solo se copia a la otra caja (sin tocar xboost para no quitar el foco)
    writeValue(src === 'main' ? stickyQty : mainQty, n);
  }, true);
  document.addEventListener('change', function (e) {
    var src = sourceOf(e.target);
    if (!src || lock) return;
    // Al confirmar (Enter o salir del campo) se ajusta todo, incluida la opción de xboost
    setQty(e.target.value, src + '-typed');
  }, true);


  // Botones − / + : capturamos el clic antes que el tema/xboost
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-selector]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) form = document.querySelector(".t4s-form__product");
    if (form !== mainForm && form !== stickyBar) return;
    var input = form.querySelector(CFG.qtyInput);
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var step = parseInt(input.step, 10) || 1;
    var cur = parseInt(input.value, 10) || 1;
    var next = btn.hasAttribute('data-increase-qty') ? cur + step : cur - step;
    setQty(next, form === mainForm ? 'main-btn' : 'sticky-btn');
  }, true);

  function setupStickyVisibility() {
    if (!stickyBar || !mainForm || !('IntersectionObserver' in window)) return;
    var passed = false;

    function apply() {
      var blocked = !passed || !!document.querySelector('.fhn-po-is-sub');
      document.documentElement.classList.toggle('fhn-sticky-hide', blocked);
      mainQty = mainForm.querySelector(CFG.qtyInput);
      stickyQty = stickyBar && stickyBar.querySelector(CFG.qtyInput);
      
      watchInput(mainQty, 'main');
      watchInput(stickyQty, 'sticky');
      if (!mainQty) return;
      var n = parseInt(mainQty.value, 10);
      if (!isNaN(n)) { desired = n; writeValue(stickyQty, n); }
    }

    // Se observa el bloque del formulario completo, que nunca se oculta
    var target = mainForm.closest('.t4s-product-form__variants') || mainForm;
    new IntersectionObserver(function (entries) {
      var r = entries[0];
      passed = !r.isIntersecting && r.boundingClientRect.bottom < 0;
      apply();
    }, { threshold: 0 }).observe(target);

    // Reaccionar al cambiar entre Suscripción y Compra única
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-po-mode]')) apply();
    });

    stickyBar.classList.add('fhn-sticky-bar');
    apply();
  }

  function init() {
    mainForm = document.querySelector(CFG.mainForm);
    setTimeout(() => {
      stickyBar = document.querySelector(CFG.stickyBar);
      if (!mainForm) return;
      mainQty = mainForm.querySelector(CFG.qtyInput);
      stickyQty = stickyBar && stickyBar.querySelector(CFG.stickyQtyInput);
      watchInput(mainQty, 'main');
      watchInput(stickyQty, 'sticky');
      setupStickyVisibility();
    }, 400);
    // Valor inicial: xboost pudo escribir la cantidad antes de que empezáramos a vigilar
    function initialSync() {
      if (!mainQty) return;
      var n = parseInt(mainQty.value, 10);
      stickyBar = document.querySelector(CFG.stickyBar);
      stickyQty = stickyBar && stickyBar.querySelector(CFG.stickyQtyInput);
      console.log({stickyQty})
      if (!isNaN(n)) { desired = n; writeValue(stickyQty, n); }
    }
    initialSync();
    setTimeout(initialSync, 500); 
    // Clic en un tier de xboost: tomar su número como cantidad
    function onTierPress(e) {
      if (!e.isTrusted || !e.target.closest(CFG.xboostRoot) || e.target.closest('select, option')) return;
      var t = tierElements().find(function (t) { return t.el.contains(e.target); });
      if (!t) return;
      var n = t.n;
      desired = n;
      // Esperamos a que xboost termine y luego escribimos en ambos campos
      [40, 200].forEach(function (ms) {
        setTimeout(function () { writeValue(mainQty, n); writeValue(stickyQty, n); }, ms);
      });
    }
    document.addEventListener('pointerdown', onTierPress, true);
  }

  // xboost se inyecta tarde: esperamos a que aparezca
  function boot(tries) {
    if (document.querySelector(CFG.xboostRoot) || tries > 40) return init();
    setTimeout(function () { boot(tries + 1); }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);
})();
